import '@cfs-fixings/shared/src/globals.css'
import 'unfonts.css'
import * as Sentry from '@sentry/react'
import App from '@/App.tsx'
import { AppRouter } from '@/routes'
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { store } from '@/stores'
import { ToastContainer } from '@cfs-fixings/shared'

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App>
          <ToastContainer />
          <AppRouter />
        </App>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
)
